function waitForJobChannel() {
  return new Promise(resolve => {
    const check = () => {
      if (window.jobChannelConnected) {
        resolve();
      } else {
        setTimeout(check, 100);
      }
    };
    check();
  });
}

if ($('body').hasClass('page-candidate_suggestions')) {
  const url = $('[data-suggest-candidates-path]')?.data('suggest-candidates-path');
  const secureChannelName = $('[data-secure-channel-name]')?.data('secure-channel-name');

  if (url) {
    waitForJobChannel().then(() => {
      $.ajax({
        type: 'GET',
        url,
        timeout: 30000,
        dataType: 'script',
        data: { secure_channel_name: secureChannelName },
        success() { },
        error() { },
      });
    });
  }
}
